import React from 'react'

export default function ProductionView(props) {


    return (
        <React.Fragment>
            <iframe src="/pdf/workflow.pdf" width="100%" height="100%" />
        </React.Fragment>
    )
}